function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-icon">?</div>
      <h1>Page Not Found</h1>
      <p>
        The page you're looking for doesn't exist or has been moved.
        Please check the link and try again.
      </p>
    </div>
  );
}

export default NotFound;
